<template lang="pug">
  footer.mt-20
    .footer-wrap.container.mx-auto.px-12.py-6.flex
      div.logo
        img(src="@/assets/logo.png")
      .address
        p <strong>FIRMA <br> Isserstedt Prüfmaschinen GmbH & Co.KG</strong> <br> Am Panneschopp 20 <br> 41334 Nettetal, Germany <br> <a href="tel:00492157827990"> Tel. +49 (0) 2157 / 82799-0 </a> <br> <a href="mailto:info@isserstedt-pruefservice.de">info@isserstedt-pruefservice.de</a>
      div.menu
        div.uppercase.font-semibold Weiteres
        Menu#footer-menu(k="footer-menu" :max-depth="1")
    .copyright

</template>

<script>
import { mapGetters } from 'vuex';

import Menu from '@/components/Menu.vue';

export default {
  name: 'Footer',
  components: {
    Menu
  },
  computed: {
    ...mapGetters({
      menus: 'menus',
      config: 'config'
    })
  }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

footer
  .copyright
    background: $isserstedt-yellow
    min-height: 30px

  .footer-wrap
    position: relative
    &:after
      position: absolute
      right: 0
      background-image: url('~@/assets/isserset_footer.png')
      background-repeat: no-repeat
      background-size: 280px auto
      width: 280px
      height: 100px
      margin-top: -80px
      margin-right: 46px
      content: ''

    .logo
      margin-right: 4rem
      > img
        max-width: 200px
    .address
      margin-right: 4rem

  @apply hidden
  @screen lg
    @apply block
    bottom: 0
    background: linear-gradient(90deg, $isserstedt-blue1 0%, $isserstedt-blue2 100%)
    width: 100%
    color: #fff
  ::v-deep
    nav#footer-menu

      // @apply mx-auto p-4 hidden
      display: none
      height: 100%
      align-items: center
      @screen lg
        display: block
      ul
        & > li
          border: 0
          &.active .tree-item a
            font-weight: 600
          .tree-item
            display: inline-block
            a
              line-height: 1
              padding: 2px 0px 4px
              transition: all .2s ease-in-out 0s
              &:hover
                font-weight: 600
</style>
